/**
 * Completely reloads the Visuiz chatbot widget with a new API URL
 * @param databaseName - The name of the selected Neo4j database
 */
export const updateChatbotApiUrl = (databaseName: string) => {
  console.log(`[Chatbot] Reloading chatbot for database: ${databaseName}`);
  
  try {
    // 1. Destroy existing chatbot instance if it exists
    const chatbotWidget = (window as any).VisuizChatbot;
    if (chatbotWidget) {
      console.log('[Chatbot] Chatbot widget object found');
      if (typeof chatbotWidget.destroy === 'function') {
        console.log('[Chatbot] Destroying existing chatbot instance');
        chatbotWidget.destroy();
      }
      // Clear the global object
      delete (window as any).VisuizChatbot;
    }

    // 2. Remove any chatbot UI elements
    const chatbotElements = document.querySelectorAll(
      '.visuiz-chatbot-container, .visuiz-chatbot-button, .visuiz-chatbot-widget, [class*="visuiz"]'
    );
    chatbotElements.forEach((element) => {
      console.log('[Chatbot] Removing UI element:', element.className);
      element.remove();
    });

    // 3. Remove the old script element
    const oldScript = document.querySelector('script[src*="visuiz-chatbot.js"]');
    if (oldScript) {
      console.log('[Chatbot] Removing old script element');
      oldScript.remove();
    }

    // 4. Wait a bit for cleanup, then create new script
    setTimeout(() => {
      console.log('[Chatbot] Creating new chatbot script');
      
      const newScript = document.createElement('script');
      newScript.src = 'https://ai.visuiz.com/visuiz-chatbot.js';
      newScript.setAttribute('data-api-url', `https://ai-api.visuiz.com/${databaseName}`);
      newScript.setAttribute('data-position', 'bottom-right');
      newScript.setAttribute('data-theme', 'green');
      newScript.defer = true;

      console.log(`[Chatbot] New API URL: https://ai-api.visuiz.com/${databaseName}`);

      // Add load handlers
      newScript.onload = () => {
        console.log('[Chatbot] ✅ Script loaded successfully');
        console.log('[Chatbot] ✅ Chatbot should now be visible');
        
        // Verify the URL
        const verifyUrl = newScript.getAttribute('data-api-url');
        console.log(`[Chatbot] Verified API URL: ${verifyUrl}`);
        
        // Log if widget initialized
        setTimeout(() => {
          if ((window as any).VisuizChatbot) {
            console.log('[Chatbot] ✅ Widget initialized successfully');
          } else {
            console.warn('[Chatbot] ⚠️ Widget object not found after initialization');
          }
        }, 500);
      };

      newScript.onerror = (error) => {
        console.error('[Chatbot] ❌ Failed to load chatbot script:', error);
      };

      // Append to body
      document.body.appendChild(newScript);
      console.log('[Chatbot] Script appended to body');
      
    }, 300); // Small delay to ensure cleanup is complete

  } catch (error) {
    console.error('[Chatbot] Error reloading chatbot:', error);
  }
};

/**
 * Initialize chatbot on first page load
 * Call this once when the app first loads
 */
export const initializeChatbot = (databaseName: string) => {
  console.log(`[Chatbot] Initial initialization for database: ${databaseName}`);
  
  // Check if script already exists in HTML
  const existingScript = document.querySelector('script[src*="visuiz-chatbot.js"]') as HTMLScriptElement;
  
  if (existingScript) {
    // Update the existing script's data-api-url
    const newApiUrl = `https://ai-api.visuiz.com/${databaseName}`;
    existingScript.setAttribute('data-api-url', newApiUrl);
    console.log(`[Chatbot] Updated initial script API URL to: ${newApiUrl}`);
  }
};